import React, { useEffect, useState } from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import BatteryChart from "../charts/BatteryChart";
import "./PatientCharts.scss";
import ModalHeader from "./ModalHeader";
import ImpedanceRangeChart from "../charts/impedanceRange";
import ImpedanceChart from "../charts/ImpedanceChart";
import StimulationChart from "../charts/StimulationChart";
import CloseIcon from "../../common/assats/chart/chartToolbar/Close.svg";
import { generateTimeRangeWithLoop } from "../../common/function/chartFunction";
import ReactSwitch from "react-switch";
import { fetchTreatmentReport } from "../../common/api/treatmentService";
import { useAlert } from "../../common/contexts/AlertContext";
interface PatientChartsProps {
  show: boolean;
  onHide: () => void;
  treatmentId: string;
}

const PatientCharts: React.FC<PatientChartsProps> = ({ show, onHide,treatmentId }) => {
  const [activeKey, setActiveKey] = useState("battery");
  const [measurements, setMeasurements] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [resistanceType, setResistanceType] = useState<"left" | "right">("left");
  const alert = useAlert();
  console.log("patientCharts");
  
  useEffect(() => {
    if (!treatmentId) return;
    async function fetchData() {
      try {
        const data = await fetchTreatmentReport(treatmentId);        
        // If data.data is not an array, wrap it in an array
        const measurementsArray = Array.isArray(data.data) ? data.data : [data.data];
        setMeasurements(measurementsArray);
      } catch (error) {
        alert("Failed to fetch treatment report", "error");
        console.error("Error fetching treatment report:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [treatmentId]);
  

  const xAxisData = measurements.map((m) =>
    m.timestamp ? new Date(m.timestamp).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : ""
  );
    
  return (
    <Modal show={show} onHide={onHide}>
      <button className="close-button" onClick={onHide} aria-label="Close">
        <img src={CloseIcon} alt="Close" />
      </button>
      <ModalHeader />
      <Modal.Body>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <Tabs activeKey={activeKey} onSelect={(k) => k && setActiveKey(k)} className="custom-tabs">
            <Tab eventKey="stimulation" title="Stimulation Chart">
              <StimulationChart measurements={measurements} xAxisData={xAxisData} />
            </Tab>
            <Tab eventKey="impedance" title="Impedance Chart">
              <div>
                <div style={{ display: "flex", marginBottom: "10px", alignItems: "center",flexDirection:"row" }}>
                  <span style={{ marginRight: "10px" }}>Left</span>
                  <ReactSwitch
                    onChange={() =>
                      setResistanceType(resistanceType === "left" ? "right" : "left")
                    }
                    checked={resistanceType === "right"}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#86d3ff"
                    offColor="#888"
                  />
                  <span style={{ marginLeft: "10px" }}>Right</span>
                </div>
                <ImpedanceChart
                  measurements={measurements}
                  xAxisData={xAxisData}
                  resistanceType={resistanceType}
                />
              </div>
            </Tab>
            <Tab eventKey="impedanceRange" title="Impedance In Range">
              <div>
              <div style={{ display: "flex", marginBottom: "10px", alignItems: "center",flexDirection:"row" }}>
                  <span style={{ marginRight: "10px" }}>Left</span>
                  <ReactSwitch
                    onChange={() =>
                      setResistanceType(resistanceType === "left" ? "right" : "left")
                    }
                    checked={resistanceType === "right"}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#86d3ff"
                    offColor="#888"
                  />
                  <span style={{ marginLeft: "10px" }}>Right</span>
                </div>
                <ImpedanceRangeChart
                  measurements={measurements}
                  xAxisData={xAxisData}
                  resistanceType={resistanceType}
                />
              </div>
            </Tab>
            <Tab eventKey="battery" title="Battery Chart">
              <BatteryChart measurements={measurements} xAxisData={xAxisData} />
            </Tab>
          </Tabs>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PatientCharts;
